export function generateSlug(information: string): string {
  const table: Record<string, string> = {
    "Æ": "ae", "Œ": "oe", "æ": "ae", "œ": "oe",
    "&": "et", "%": "pourcents", "/": "-", ":": "-", "|": "-", "?": "-",
  };

  return information
    .replace(/\s\s+/g, " ")
    .split("")
    .map((char) => table[char] ?? char)
    .join("")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")   // accents via Unicode
    .toLowerCase()
    .replace(/['''`]/g, "-")           // apostrophes
    .replace(/\s+/g, "-")             // espaces → tiret (uniformisé)
    .replace(/[^a-z0-9-]/g, "")       // supprime le reste
    .replace(/-+/g, "-")              // collapse tirets multiples
    .replace(/^-+|-+$/g, "");         // trim tirets en début/fin
}